import React, { useEffect } from 'react';
import ConsentGuard from './ConsentGuard';

// Modul-weites Flag: Das Embed-Skript deklariert globale Bezeichner und darf
// pro Seitenladung nur EINMAL ausgeführt werden – ein zweites Einfügen (z. B.
// nach Consent-Wechsel oder im StrictMode-Remount) wirft sonst einen
// SyntaxError ("Identifier ... has already been declared"). Ein Cleanup ist
// zwecklos: das Entfernen des Script-Tags nimmt die Deklarationen nicht zurück.
let metarScriptInjected = false;

const MetarWidgetContent: React.FC = () => {
  useEffect(() => {
    if (metarScriptInjected) return;
    metarScriptInjected = true;

    const script = document.createElement('script');
    script.src = 'https://metar-taf.com/embed-js/EDEB?qnh=hPa&rh=rh&target=aal5NdeK';
    script.async = true;
    script.defer = true;

    document.body.appendChild(script);
  }, []);

  return (
    <div className="mt-4 mb-10 mx-auto" style={{ maxWidth: '300px' }}>
      <a 
        href="https://metar-taf.com/metar/EDEB" 
        id="metartaf-aal5NdeK" 
        style={{
          fontSize: '18px',
          fontWeight: 500,
          color: '#000',
          width: '300px',
          height: '435px',
          display: 'block'
        }}
      >
        METAR Bad Langensalza Airfield
      </a>
    </div>
  );
};

const MetarWidget: React.FC = () => {
  return (
    <ConsentGuard title="METAR Wetter-Daten">
      <MetarWidgetContent />
    </ConsentGuard>
  );
};

export default MetarWidget;
